import { render, staticRenderFns } from "./InvoiceReceiptPage.vue?vue&type=template&id=22be58d2&scoped=true&"
import script from "./InvoiceReceiptPage.vue?vue&type=script&lang=js&"
export * from "./InvoiceReceiptPage.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceReceiptPage.vue?vue&type=style&index=0&id=22be58d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22be58d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Projects/Coding/Nhafatura/appfactura-spa/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VContainer,VDivider,VFlex,VLayout})
